import React from "react";
import { ArrowRightIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/checkout";
type CtaButtonProps = {
  label: string;
  id?: string;
  className?: string;
};
export function CtaButton({
  label,
  id,
  className = ""
}: CtaButtonProps) {
  return <a id={id} href={CHECKOUT_URL} className={`flex w-full items-center justify-center gap-2 rounded-2xl bg-cta px-5 py-[18px] text-center text-[16px] font-extrabold uppercase leading-snug tracking-wide text-white shadow-[0_6px_0_0_#0e6b31] transition-[transform,box-shadow,background-color] duration-150 ease-out hover:bg-cta-hover active:translate-y-[3px] active:shadow-[0_3px_0_0_#0e6b31] focus:outline-none focus-visible:ring-4 focus-visible:ring-gold sm:text-lg ${className}`} data-id="element-21" data-mp="hhj3d0iyfxzm">
      <span data-id="element-22" data-mp="19b1mlxg66c3j">{label}</span>
      <ArrowRightIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-23" data-mp="19aa15fgaduqz" />
    </a>;
}